import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalSelector = (state: ReduxState) => number
const getTotal: TotalSelector = state => state.tasksQueue.updateLandingsTasksPagination.total

export const updateLandingsTasksTotalSelector: TotalSelector = createSelector(getTotal, total => total)
